import { createContext, useContext } from 'react';

const DEFAULT_SCOPE = 'GLOBAL';

const FormInputHandleManagerScopeContext = createContext(DEFAULT_SCOPE);

export const useFormInputHandleManagerScopeContext = () => {
    return useContext(FormInputHandleManagerScopeContext);
};

/**
 * Create a scope around a section of the form so that
 * when we register inputs, we know which section
 * of the form those inputs belong to.
 */
export const FormInputHandleManagerScopeContextProvider = (
    props: React.PropsWithChildren<{ value?: string }>
) => {
    return (
        <FormInputHandleManagerScopeContext.Provider value={props.value || DEFAULT_SCOPE}>
            {props.children}
        </FormInputHandleManagerScopeContext.Provider>
    );
};
